module.exports = __webpack_public_path__ + "media/Bronislaw_Krzysztof.a81023ef.mp4";